import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  boxes: [],
  countBoxes: 0,
  boxesInClient: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/boxes/index.js